import React from 'react';
import { HeadingWrapper, Heading, GenericP } from '../Styles';
import ToolTip from '../Tooltip/Tooltip';
import { HelpWrapper, LinkHelpList } from './PageHeadingStyles';

const PageHeading = (props) => {
	const { headingText, links, children, width, martop, fontSize, isTipActive = false } = props;

	const headingWrapperClickHandler = (e) => {
		e.stopPropagation();
	};
	return (
		<HeadingWrapper headingWidth={width || 'auto'} onClick={headingWrapperClickHandler}>
			<Heading as='h1' marBt='10px' martop={martop} font_size={fontSize || '36'}>{headingText}</Heading>
			{(links && links.length) ? (
				<HelpWrapper>
					<a>Help</a>
					<ToolTip top_arr display={isTipActive ? 'block' : 'none'} bg_color='#fff' posTop='120%' posLeft='-25px' left='15%'>
						<GenericP f_weight={900} bottom_M={5} color='#000'>
							How can we help you?
						</GenericP>
						{links.map((link) => (
							<LinkHelpList
								onClick={link.onClick}
								href={link.href}
								key={link.text}
								className='helpList'>
								{link.text}
							</LinkHelpList>
						))}
					</ToolTip>
				</HelpWrapper>
			) : null}
			{children}
		</HeadingWrapper>
	);
};
export default PageHeading;
